import { render, staticRenderFns } from "./goodstockList.vue?vue&type=template&id=6b7ac87e"
import script from "./goodstockList.vue?vue&type=script&lang=js"
export * from "./goodstockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports